import React from "react"
import ButtonBase, {ButtonBaseProps} from "@mui/material/ButtonBase"
import {SxProps, Theme as MuiTheme} from "@mui/material/styles"

interface BlueButtonProps extends Omit<ButtonBaseProps, "sx"> {
  href?: string
  sx?: SxProps<MuiTheme>
}

export default function BlueButton({sx, children, ...props}: BlueButtonProps) {
  return (
    <ButtonBase
      {...props}
      sx={[
        {
          height: 60,
          borderRadius: "30px",
          color: "white",
          background: "linear-gradient(90deg, #00d1f2 0%, #00a8e0 100%)",
          px: "60px",
          fontSize: 17,
          fontWeight: 500,
          textTransform: "none",
          transition: "transform 0.2s",
          textDecoration: "none",
          "&:hover": {
            transform: "scale(1.05)",
            textDecoration: "none",
            color: "white",
          },
          "&:active": {
            opacity: 0.6,
          },
          "&.Mui-disabled": {
            opacity: 0.5,
          },
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    >
      {children}
    </ButtonBase>
  )
}
